import { createMuiTheme } from '@material-ui/core/styles';
import { palette, typography } from './utils';
import * as c from './components';
const theme = createMuiTheme({
  palette,
  typography,
  spacing: 8,
  overrides: {
    MuiInput: {
      input: {
        '&::placeholder': {
          color: 'gray'
        }
      }
    },
    MuiButton: c.button,
    MuiInputLabel: c.inputLabel,
    MuiInputBase: c.inputBase,
    MuiFormHelperText: c.formHelperText,
    MuiOutlinedInput: c.outlinedInput,
    MuiSvgIcon: c.svgIcon,
    MuiStep: c.step,
    MuiStepConnector: c.stepConnector,
    MuiStepLabel: c.stepLabel,
    MuiStepButton: c.stepButton,
    MuiCard: c.card,
    MuiCardActionArea: c.cardActionArea,
    MuiCardMedia: c.cardMedia,
    MuiSelect: c.select,
    MuiList: c.list
  }
});
export default theme;